import { render, staticRenderFns } from "./ProductVersionsTable.vue?vue&type=template&id=179d1d83&scoped=true"
import script from "./ProductVersionsTable.vue?vue&type=script&lang=ts"
export * from "./ProductVersionsTable.vue?vue&type=script&lang=ts"
import style0 from "./ProductVersionsTable.vue?vue&type=style&index=0&id=179d1d83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d1d83",
  null
  
)

export default component.exports